import { useMemo } from 'react';

import {
  InteractiveResponseViewScaler,
  InteractiveResponseTitle,
} from '../../shared/interactive-response-shared';
import {
  CATEGORISE_DROP_ITEM_SIZE,
  RESPONSE_FREE,
  ViewProps,
} from '../interactive-response-categorise.constants';
import { InteractiveDropDisplay } from './interactive-response-categorise-drop-display';
import { InteractiveCategoriseDropItemTarget } from './interactive-response-categorise-drop.style';
import { initialise } from './interactive-response-categorise-play.utils';
import { getShouldShowNumberOfItemsHint } from '../settings/interactive-response-categorise.utils';
import InteractiveDragDisplay from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-display';
import * as Styled from './interactive-response-categorise.style';

const InteractiveResponseCategorisePreviewSuggestedAnswer = ({
  properties,
}: ViewProps & {
  instructionHeight?: number;
}) => {
  const isFreeResponse =
    properties.interactiveResponseCategorise.answerType === RESPONSE_FREE;
  const isShowNumberOfItemsHint = getShouldShowNumberOfItemsHint(
    properties.interactiveResponseCategorise.showNumberOfItemsHint
  );

  const { dragItems, dropItems } = useMemo(() => {
    return initialise({
      items: properties.interactiveResponseCategorise.items,
      categories: properties.interactiveResponseCategorise.categories,
      showAnswer: !isFreeResponse,
      isShowNumberOfItemsHint,
      shouldShuffle: false,
      variant: properties.interactiveResponseCategorise.variant,
    });
  }, [
    isFreeResponse,
    isShowNumberOfItemsHint,
    properties.interactiveResponseCategorise.items,
    properties.interactiveResponseCategorise.categories,
    properties.interactiveResponseCategorise.variant,
  ]);

  return (
    <InteractiveResponseViewScaler
      key={properties.interactiveResponseCategorise.answerType}
    >
      <InteractiveResponseTitle
        title={properties.interactiveResponseCategorise.title}
        subTitle={properties.interactiveResponseCategorise.subTitle}
      />

      <Styled.InteractiveResponseCategories>
        {dropItems.map(dropItem => {
          const answers = dragItems.filter(d => d.value === dropItem.id);
          return (
            <Styled.InteractiveResponseCategory key={dropItem.id}>
              <Styled.InteractiveResponseCategoryLabel>
                {dropItem.label}
              </Styled.InteractiveResponseCategoryLabel>
              <InteractiveCategoriseDropItemTarget>
                {dropItem.zones.map((_, index) => {
                  const dragItem = answers[index];
                  return (
                    <InteractiveDropDisplay
                      key={index}
                      hasDropped
                      isContinuousMarking={false}
                    >
                      {dragItem && (
                        <InteractiveDragDisplay
                          scaleTo={CATEGORISE_DROP_ITEM_SIZE}
                          imageUrl={dragItem.question.image?.small}
                          isFit={dragItem.question.image?.isFit}
                          description={
                            dragItem.question.image?.description || ''
                          }
                          baseColour={dragItem.question.baseColour || null}
                          text={dragItem.question.text || null}
                          richtext={dragItem.question.richtext || null}
                          variant={dragItem.question.variant}
                        />
                      )}
                    </InteractiveDropDisplay>
                  );
                })}
              </InteractiveCategoriseDropItemTarget>
            </Styled.InteractiveResponseCategory>
          );
        })}
      </Styled.InteractiveResponseCategories>
    </InteractiveResponseViewScaler>
  );
};

export default InteractiveResponseCategorisePreviewSuggestedAnswer;
